module.exports = __webpack_public_path__ + "files/OBSERVA4.05e1817dfc2e16813cfd462db81fc0ed.zip";